import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-channel-dialog',
  templateUrl: './edit-lead-channel-dialog.component.html',
  styleUrls: ['./lead-channel.component.css']
})
export class EditLeadChannelDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditLeadChannelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
